export default __webpack_public_path__ + "static/service-bg-70917ce002616cd6570918c3dae87085.png";